/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="brand">
      <span class="created-by">© {{year}} Autos Orientales Picacho S.A.P.I.</span>
    </div>
  `,
})
export class FooterComponent {
  year:number;
  get currentYear(): number {
    return new Date().getFullYear();
  }
  
  constructor(){
    this.year =new Date().getFullYear();
  }
}
